import { useState } from "react";
import { RailCard, RailRow, railInput, railLink } from "./RailCard";
import { getDefaultFreightMargin, getDefaultRates } from "../proposalUtils";

const FIELDS = [["material", "Material GM %"], ["labor", "Labor GM %"], ["freight", "Freight GM %"]];
const isSet = (v) => v != null && v !== "";
const fmtPct = (v) => String(Math.round((Number(v) || 0) * 10) / 10);

// Proposal-wide GM% defaults. Blank = Settings → Default Rates. "Apply to all" overwrites every existing line.
export function MarginsCard({ defaults, onChange, onApplyAll, lineCount }) {
  const [confirm, setConfirm] = useState(false);
  const d = defaults || {};
  const anySet = FIELDS.some(([k]) => isSet(d[k]));
  const rates = getDefaultRates();
  const fallback = { material: rates.material_margin, labor: rates.labor_margin, freight: getDefaultFreightMargin() };
  return (
    <RailCard title="MARGINS" testId="rail-margins">
      {FIELDS.map(([k, label]) => (
        <RailRow key={k} label={label} hint="Blank = Settings default · used for every line added to this proposal from now on">
          <input type="number" step="1" min="0" max="99" value={isSet(d[k]) ? d[k] : ""} placeholder={fmtPct(fallback[k])}
            onChange={(e) => onChange({ ...d, [k]: e.target.value })} onFocus={(e) => e.target.select()}
            className={railInput} data-testid={`rail-margin-${k}`} />
        </RailRow>
      ))}
      <RailRow label={<span className="text-[11px]">Defaults for New Lines</span>} testId="rail-margins-footer">
        {!confirm ? (
          <button type="button" className={railLink} disabled={!anySet || !lineCount} onClick={() => setConfirm(true)}
            title={anySet ? "Overwrite the GM% on every existing line with these defaults" : "Type a margin first"} data-testid="rail-margins-apply-all">
            Apply to All {lineCount} Line{lineCount === 1 ? "" : "s"}
          </button>
        ) : (
          <span className="flex items-center gap-1.5 text-[11px]" data-testid="rail-margins-apply-confirm-row">
            <span className="text-amber-700">Overwrite {lineCount}?</span>
            <button type="button" className="font-semibold text-emerald-700 hover:underline" onClick={() => { onApplyAll(); setConfirm(false); }} data-testid="rail-margins-apply-confirm">Yes</button>
            <button type="button" className="text-slate-500 hover:underline" onClick={() => setConfirm(false)} data-testid="rail-margins-apply-cancel">No</button>
          </span>
        )}
      </RailRow>
    </RailCard>
  );
}
